import React from 'react'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import { listFeature, listOfferItem } from '../landing/data'
import OfferItem from '../landing/components/offer-item/offer-item'
import CustomSlider from '../../components/custom-slider/custom-slider'
import Slider from "react-slick";
import SectionTC from '../../components/section-tc/section-tc'
import PaymentMethods from '../landing/components/payment-methods/payment-methods'
import styled from 'styled-components'
import { device } from '../../config/theme/breakpoints'
import FeatureItem from '../landing/components/feature-item/feature-item'
import { ExclamationCircle } from '@styled-icons/heroicons-outline'
import AlertTC from '../../components/alert-tc/alert-tc'
import { listSummary } from './data'
import ItemDetail from './item-detail/item-detail'
import busImage from '../../assets/img/bus_icon.png'
import checkImage from '../../assets/img/check_icon.png'

const FeatureCustomClass = `
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: 15px;
  padding-top: 5px;
  padding-bottom: 5px;

  @media ${device.mobileL}{
    justify-content: space-around;
  }
`
const ContainerSummary = styled.div`
  margin-top: 60px;
  margin-bottom: 60px;
`

const TitleSummary = styled.div`
  > div h3{
    color: ${p => p.theme.palette.primary.main};
    font-weight: 300;

    > b {
        font-weight: bold;
    }

    }

    > p {
        text-align: right;
    }
`
const DividerProgress = styled.div`
  width: 100%;
  height: 4px;
  background: ${p => p.theme.palette.text.grayLight};
  position: relative;
  border-radius: 2px 2px 10px 10px;

  :after{
    content: '';
    background: ${p => p.theme.palette.primary.main};
    width: 20%;
    height: 4px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 2px 0 0 10px;
  }
`
const SummaryInfo = styled.div`
  box-shadow: 0 3px 6px rgb(0,0,0, 6%);
  padding: 40px;
  border-radius: 15px;
`
const ContainerHeaderInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  aling-items: center;
`
const ContainerPlaca = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  aling-items: center;

  > div{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > div img {
    max-width: 20px;
    margin-right: 10px;
  }

  > div p{
    margin: 0;
  }

  > div span{
    font-weight: bold;
  }
`
const ContainerInfoBottom = styled.div`
  padding: 20px;
`

const ContainerStatus = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  aling-items: center;

  > div{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > div img {
    max-width: 20px;
    margin-right: 10px;
  }

  > div p{
    margin: 0;
  }

  > div span{
    font-weight: bold;
    color: #1EDE91;
  }
`

const ParcelSearch: React.FunctionComponent = () => {
  const sliderOfferRef = React.useRef<Slider>(null);

  return (
    <Layout>
        <HeaderOptions>
          <SectionTC className={FeatureCustomClass}>
            {listFeature.map(feature => (
              <FeatureItem
                key={feature.id}
                icon={feature.icon}
                title={feature.title}
                subTitle={feature.subTitle}
                description={feature.description}
              />
            ))}
          </SectionTC>
        </HeaderOptions>
        <SectionTC>
            <ContainerSummary>
                <TitleSummary>
                    <div><h3><b>Resultado (s)</b> de búsqueda de encomienda</h3></div>
                    <DividerProgress />
                    <p>Se ha(n) encontrado: <b>1 resultado (s)</b></p>
                </TitleSummary>
                <SummaryInfo>
                    <ContainerHeaderInfo>
                        <ContainerPlaca>
                          <div>
                            <img src={busImage} alt='Imagen de bus'/>
                          </div>
                          <div>
                            <p>Placa del bus: <span>T54821</span></p>
                          </div>
                        </ContainerPlaca>
                        <ContainerStatus>
                          <div>
                            <img src={checkImage} alt='Imagen de check'/>
                          </div>
                          <div>
                            <p>Estado: <span>Entregado</span></p>
                          </div>
                        </ContainerStatus>
                    </ContainerHeaderInfo>
                    <ContainerInfoBottom>
                      {listSummary.map(item => (
                        <ItemDetail key={item.id} title={item.title} description={item.description}/>
                      ))}
                    </ContainerInfoBottom>
                </SummaryInfo>
            </ContainerSummary>
            <AlertTC icon={<ExclamationCircle />} title="Envío y recepción de encomiendas" description='Verificar que los usuarios del servicio de envío y recepción de encomiendas cumplan con la normativa implementada por la empresa para brindar seguridad al servicio ofrecido'/>
        </SectionTC>
        <SectionTC>
          <PaymentMethods />
        </SectionTC>
        <CustomSlider
          sliderRef={sliderOfferRef}
          preTitle='Principales destinos'
          title='Y promociones'
          size={listOfferItem.length}
          withIconRight
        >
          {listOfferItem.map(offer => (
            <div key={offer.id}>
              <OfferItem
                  tour={offer.tour}
                  price={offer.price}
                  title={offer.title}
                  subTitle={offer.subTitle}
                  image={offer.image}
                />
            </div>
          ))}
        </CustomSlider>
    </Layout>
  )
}

export default ParcelSearch